import React from 'react';
import {BrowserRouter as Router, Link, Route, Routes} from 'react-router-dom';
import MainLayout from "./layouts/MainLayout/MainLayout";
import HomePage from "./pages/Home/Home";
import AboutPage from "./pages/About/About";
import EmployeesPage from "./pages/Employees/Employees";
import DocsPage from "./pages/Docs/Docs";
import FAQPage from "./pages/FAQ/FAQ";
import ContactsPage from "./pages/Contacts/Contacts";
import AdminLoginPage from "./pages/Admin/AdminLogin/AdminLogin";
import {SnackbarProvider} from "./components/ui/snackbar/snackbar";
import {withCookies} from "react-cookie";
import AdminLayout from "./layouts/AdminLayout/AdminLayout";
import AdminRedirectPage from "./pages/Admin/AdminRedirect/AdminRedirectPage";
import AdminPanelPage from "./pages/Admin/AdminPanelPage/AdminPanelPage";
import AdminPanelServicesPage from "./pages/Admin/AdminPanelServices/AdminPanelServicesPage";
import AdminPanelServicesCategoryPage from "./pages/Admin/AdminPanelServicesCategory/AdminPanelServicesCategoryPage";
import AdminPanelServicesCategorySubcategoryPage
    from "./pages/Admin/AdminPanelServicesCategorySubcategory/AdminPanelServicesCategorySubcategoryPage";
import AdminPanelEmployeesPage from "./pages/Admin/AdminPanelEmployees/AdminPanelEmployeesPage";
import AdminPanelVacanciesPage from "./pages/Admin/AdminPanelVacanciesPage/AdminPanelVacanciesPage";
import AdminPanelFAQPage from "./pages/Admin/AdminPanelFAQPage/AdminPanelFAQPage";
import AdminPanelArticlesPage from "./pages/Admin/AdminPanelArticlesPage/AdminPanelArticlesPage";
import AdminPanelDocsPage from "./pages/Admin/AdminPanelDocsPage/AdminPanelDocsPage";
import AdminPanelBannerPage from "./pages/Admin/AdminPanelBannerPage/AdminPanelBannerPage";
import AdminPanelUsersPage from "./pages/Admin/AdminPanelUsersPage/AdminPanelUsersPage";
import ServicesPage from "./pages/Services/Services";
import ArticlesPage from "./pages/Articles/Articles";
import ArticlesArticlePage from "./pages/ArticlesArticle/ArticlesArticlePage";
import AdminPanelDocsEmployeesPage from "./pages/Admin/AdminPanelDocsEmployeesPage/AdminPanelDocsEmployeesPage";


function NotFoundPage() {
    return (
        <div className='not-found-page'>
            <div className='code'>
                404
            </div>
            <div className='content'>
                <div className='title'>
                    Такой страницы не существует
                </div>
                <div className='description'>
                    Или вы ввели неправильный адрес
                </div>
            </div>
            <Link className='button' to='/'>
                На главную
            </Link>
        </div>
    );
}

class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    componentDidMount() {

    }

    render() {
        const {addSnackbar} = this.props;

        return <Router>
            <Routes>
                <Route element={<MainLayout addSnackbar={addSnackbar}/>}>
                    <Route path="/"
                           element={<HomePage addSnackbar={addSnackbar}/>}/>
                    <Route path="/about/"
                           element={<AboutPage addSnackbar={addSnackbar}/>}/>
                    <Route path="/employees/"
                           element={<EmployeesPage addSnackbar={addSnackbar}/>}/>
                    <Route path="/services/"
                           element={<ServicesPage addSnackbar={addSnackbar}/>}/>
                    <Route path="/contacts/"
                           element={<ContactsPage addSnackbar={addSnackbar}/>}/>
                    <Route path="/faq/"
                           element={<FAQPage addSnackbar={addSnackbar}/>}/>
                    <Route path="/articles/"
                           element={<ArticlesPage addSnackbar={addSnackbar}/>}/>
                    <Route path="/articles/:articleId/"
                           element={<ArticlesArticlePage addSnackbar={addSnackbar}/>}/>
                    <Route path="/docs/"
                           element={<DocsPage addSnackbar={addSnackbar}/>}/>
                    <Route path="*" element={<NotFoundPage/>}/>
                </Route>
                <Route>
                    <Route path="/admin/login/"
                           element={<AdminLoginPage addSnackbar={addSnackbar} cookies={this.props.cookies}/>}/>
                </Route>
                <Route path="/admin/" element={<AdminRedirectPage/>}/>
                <Route element={<AdminLayout cookies={this.props.cookies} addSnackbar={addSnackbar}/>}>
                    <Route path="/admin/panel/"
                           element={<AdminPanelPage/>}/>
                    <Route path="/admin/panel/services/"
                           element={<AdminPanelServicesPage addSnackbar={addSnackbar}/>}/>
                    <Route path="/admin/panel/services/:categoryId/"
                           element={<AdminPanelServicesCategoryPage addSnackbar={addSnackbar}/>}/>
                    <Route path="/admin/panel/services/:categoryId/:subcategoryId"
                           element={<AdminPanelServicesCategorySubcategoryPage addSnackbar={addSnackbar}/>}/>
                    <Route path="/admin/panel/employees/"
                           element={<AdminPanelEmployeesPage addSnackbar={addSnackbar}/>}/>
                    <Route path="/admin/panel/vacancies/"
                           element={<AdminPanelVacanciesPage addSnackbar={addSnackbar}/>}/>
                    <Route path="/admin/panel/faq/"
                           element={<AdminPanelFAQPage addSnackbar={addSnackbar}/>}/>
                    <Route path="/admin/panel/articles/"
                           element={<AdminPanelArticlesPage addSnackbar={addSnackbar}/>}/>
                    <Route path="/admin/panel/docs/"
                           element={<AdminPanelDocsPage addSnackbar={addSnackbar}/>}/>
                    <Route path="/admin/panel/empdocs/"
                           element={<AdminPanelDocsEmployeesPage addSnackbar={addSnackbar}/>}/>
                    <Route path="/admin/panel/banner/"
                           element={<AdminPanelBannerPage addSnackbar={addSnackbar}/>}/>
                    <Route path="/admin/panel/users/"
                           element={<AdminPanelUsersPage addSnackbar={addSnackbar}/>}/>
                </Route>
            </Routes>
        </Router>
    }
}


const ConnectedApp = withCookies(App);
export default () => (
    <SnackbarProvider>
        <ConnectedApp/>
    </SnackbarProvider>
);
